import { render } from "./AddMortgagePage.vue?vue&type=template&id=e143600a&scoped=true"
import script from "./AddMortgagePage.vue?vue&type=script&lang=js"
export * from "./AddMortgagePage.vue?vue&type=script&lang=js"

import "./AddMortgagePage.vue?vue&type=style&index=0&id=e143600a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e143600a"]])

export default __exports__